import { useEffect, useState } from 'react';

/**
 * Tracks whether the viewport is below `breakpointPx` (default 768 — Tailwind's `md`).
 * Returns true while the window is narrow enough that desktop multi-column
 * layouts should collapse to a stacked / tabbed mobile layout.
 *
 * Server-safe: defaults to `false` when `window` is not defined (SSR / first paint).
 */
export const useIsMobile = (breakpointPx = 768) => {
  const compute = () => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpointPx;
  };
  const [isMobile, setIsMobile] = useState(compute);
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onResize = () => setIsMobile(compute());
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpointPx]);
  return isMobile;
};

export default useIsMobile;
